/** @jsxImportSource @emotion/react */
import React from 'react';

import {css} from '@emotion/react';

import {LAYOUT} from '@/constants/appStyle';
import {useWifiSettingContext} from '@/contexts/WifiSettingContext';

import {WifiConfig} from './WifiConfig';

function WifiConfigContainer() {
  const {selectedWifi} = useWifiSettingContext();

  const WifiConfigStyle = css({
    height: `calc(${LAYOUT.heightResolution} - (${LAYOUT.bottomMenuHeight} + ${LAYOUT.topMenuHeight}) - 10px)`,
    width: '100%',
    padding: '0px 15px',
    overflowY: 'auto',
    marginLeft: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    label: {
      display: 'flex',
    },
  });

  return <div css={WifiConfigStyle}>{selectedWifi && !selectedWifi.IsConnected ? <WifiConfig /> : null}</div>;
}
export default WifiConfigContainer;
